import errors from './errors';
import themes from './theme';
import features from './features';
import common from '../common';
import { CAI_MATERIAL } from '@cai/material';

export default {
  ...common,
  mobileTicket: 'Мобилен билет',
  ...features,
  save: 'Запази',
  username: 'Потребителско име',
  password: 'Парола',
  login: 'Вход',
  required: 'Задължително',
  light: 'Светъл',
  dark: 'Тъмен',
  rememberMe: 'Запомни ме',
  eula: 'EULA',
  copyright: '© {year} - Command Alkon, Inc.',
  termsAndConditions: 'Условия за ползване',
  privacyPolicy: 'Политика за поверителност',
  customer: 'Клиент',
  project: 'Проект',
  isBillable: 'Фактурируем',
  dispatchDateTime: 'Дата',
  orderId: 'Поръчка',
  ticketId: 'Билет',
  location: 'Местоположение',
  vehicleTypeName: 'Превозно средство',
  product: 'Продукт',
  products: 'Продукт',
  salesTax: 'Данък върху продажбите',
  totalPrice: 'Общо',
  extendedPrice: 'Ext',
  destination: 'Дестинация',
  productId: 'Продукт',
  statusCode: 'Статус',
  vehicleTypeId: 'Идентификатор на тип превозно средство',
  locationId: 'Идентификатор на местоположение',
  customerId: 'Идентификатор на клиент',
  projectId: 'Идентификатор на проект',
  dispatchTime: 'Час',
  showAll: 'Покажи всички',
  hideAll: 'Скрий всички',
  undoChanges: 'Отмени промените',
  resetColumns: 'Нулирай колоните',
  displayRowCount: `Показване на {count, plural, 
    =0 {0 реда}
    one {# ред}
    other {# реда}
  }`,
  columnFilters: 'Филтри на колоните',
  visible: 'Видимо',
  hidden: 'Скрито',
  itemDetail: 'Детайли на артикула',
  quantity: 'Количество',
  quantityMaxWaterToAdd: 'Количество (Макс. вода за добавяне: {maxWaterQuantity})',
  unloadingMethod: 'Метод на разтоварване',
  time: 'Време',
  eventStatus: 'Статус',
  MTQ_abbr: 'm\u00B3',
  EA_abbr: 'ea',
  LTR_abbr: 'L',
  YDQ_abbr: 'y³',
  GLL_abbr: 'gal',
  MTQ_text: 'Кубични метри',
  M3_text: 'Кубични метри',
  EA_text: 'Бройка',
  LTR_text: 'Литри',
  YDQ_text: 'Кубични ярдове',
  GLL_text: 'Галон',
  ACR_text: 'Акра',
  HUR_text: 'Час',
  INH_text: 'Инча',
  FOT_text: 'Фут',
  YRD_text: 'Ярд',
  MMT_text: 'Милиметър',
  CMT_text: 'Сантиметър',
  MTR_text: 'Метър',
  SMI_text: 'Мили (статутна миля)',
  KMT_text: 'Километър',
  INK_text: 'Квадратен инч',
  FTK_text: 'Квадратен фут',
  YDK_text: 'Квадратен ярд',
  MIK_text: 'Квадратна миля',
  CMK_text: 'Квадратен сантиметър',
  MTK_text: 'Квадратен метър',
  KMK_text: 'Квадратен километър',
  INQ_text: 'Кубичен инч',
  MMQ_text: 'Кубичен милиметър',
  FTQ_text: 'Кубичен фут',
  CMQ_text: 'Кубичен сантиметър',
  OZA_text: 'Течна унция',
  PT_text: 'Пинта',
  QT_text: 'Кварта',
  MLT_text: 'Милилитър',
  ONZ_text: 'Унция',
  LBR_text: 'Фунт',
  STN_text: 'Тона',
  GRM_text: 'Грам',
  KGM_text: 'Килограм',
  TNE_text: 'Тона',
  PS_text: 'Фунта на квадратен инч',
  MPA_text: 'Мегапаскал',
  C56_text: 'Нютон на квадратен милиметър',
  C62_text: 'Един',
  NL_text: 'Товар',
  MT_text: 'Подложка',
  P1_text: 'Процент',
  CEL_text: 'Градус Целзий',
  FAH_text: 'Градус Фаренхайт',
  BLL_text: 'Варел',
  CLT_text: 'Сантилитър',
  DLT_text: 'Децилитър',
  GLI_text: 'Имперски галон',
  '2U_text': 'Мегаграм',
  SA_text: 'Чанта',
  '60_text': 'Процент тегло',
  BG_text: 'Торба',
  SEC_text: 'Секунда',
  MIN_text: 'Минута',
  '64_text': 'Фунт на квадратен инч - Калибър',
  SP_text: 'Пакет за рафт',
  MMK_text: 'Квадратен милиметър',
  MTN_text: 'Метрична тонa',
  GT_text: 'Гигатон',
  '/NL_text': 'На товар',
  '/EA_text': 'На количество',
  '/H/ + h_text': 'На час',
  '/YQ/ + YDQ_text': 'На кубичен ярд',
  '/MQ/ + MTQ_text': 'На кубичен метър',
  '/MN/ + MIN_text': 'На минута',
  '/MT_text': 'На метър',
  DSG_text: 'Дозировка',
  '/C_text': 'На 100 тегло',
  '64_2_text': 'Конкретен',
  MTQ: `{value, plural,
    =0 {0 m\u00B3}
    one {1 m\u00B3}
    other {# m\u00B3}
  }`,
  M3: `{value, plural,
    =0 {0 m\u00B3}
    one {1 m\u00B3}
    other {# m\u00B3}
  }`,
  LTR: `{value, plural,
    =0 {0 литра}
    one {1 литър}
    other {# литра}
  }`,
  TO: `{value, plural,
    =0 {0 тона}
    one {1 тон}
    other {# тона}
  }`,
  ITEM: `{value, plural,
    =0 {0 единици}
    one {1 единица}
    other {# единици}
  }`,
  YDQ_short: `{value, plural,
    =0 {0 y³}
    one {1 y³}
    other {# y³}
  }`,
  YDQ: `{value, plural,
    =0 {0 кубични ярда}
    one {1 кубичен ярд}
    other {# кубични ярда}
  }`,
  GLL: `{value, plural,
    =0 {0 галона}
    one {1 галон}
    other {# галона}
  }`,
  EA: `{value, plural,
    =0 {0 броя}
    one {1 брой}
    other {# броя}
  }`,
  MIN: `{value, plural,
    =0 {0 минути}
    one {1 минута}
    other {# минути}
  }`,
  ACR: `{value, plural,
    =0 {0 акра}
    one {1 акър}
    other {# акра}
  }`,
  HUR: `{value, plural,
    =0 {0 часа}
    one {1 час}
    other {# часа}
  }`,
  INH: `{value, plural,
    =0 {0 инча}
    one {1 инч}
    other {# инча}
  }`,
  FOT: `{value, plural,
    =0 {0 фута}
    one {1 фут}
    other {# фута}
  }`,
  YRD: `{value, plural,
    =0 {0 ярда}
    one {1 ярд}
    other {# ярда}
  }`,
  MMT: `{value, plural,
    =0 {0 милиметра}
    one {1 милиметър}
    other {# милиметра}
  }`,
  CMT: `{value, plural,
    =0 {0 сантиметра}
    one {1 сантиметър}
    other {# сантиметра}
  }`,
  MTR: `{value, plural,
    =0 {0 метра}
    one {1 метър}
    other {# метра}
  }`,
  SMI: `{value, plural,
    =0 {0 мили (статутни мили)}
    one {1 миля (статутна миля)}
    other {# мили (статутни мили)}
  }`,
  KMT: `{value, plural,
    =0 {0 километра}
    one {1 километър}
    other {# километра}
  }`,
  INK: `{value, plural,
    =0 {0 кв. инча}
    one {1 кв. инч}
    other {# кв. инча}
  }`,
  FTK: `{value, plural,
    =0 {0 кв. фута}
    one {1 кв. фут}
    other {# кв. фута}
  }`,
  YDK: `{value, plural,
    =0 {0 кв. ярда}
    one {1 кв. ярд}
    other {# кв. ярда}
  }`,
  MIK: `{value, plural,
    =0 {0 кв. мили}
    one {1 кв. миля}
    other {# кв. мили}
  }`,
  CMK: `{value, plural,
    =0 {0 кв. сантиметра}
    one {1 кв. сантиметър}
    other {# кв. сантиметра}
  }`,
  MTK: `{value, plural,
    =0 {0 кв. метра}
    one {1 кв. метър}
    other {# кв. метра}
  }`,
  KMK: `{value, plural,
    =0 {0 кв. километра}
    one {1 кв. километър}
    other {# кв. километра}
  }`,
  INQ: `{value, plural,
    =0 {0 куб. инча}
    one {1 куб. инч}
    other {# куб. инча}
  }`,
  MMQ: `{value, plural,
    =0 {0 куб. милиметра}
    one {1 куб. милиметър}
    other {# куб. милиметра}
  }`,
  FTQ: `{value, plural,
    =0 {0 куб. фута}
    one {1 куб. фут}
    other {# куб. фута}
  }`,
  CMQ: `{value, plural,
    =0 {0 куб. сантиметра}
    one {1 куб. сантиметър}
    other {# куб. сантиметра}
  }`,
  OZA: `{value, plural,
    =0 {0 флуидни унции}
    one {1 флуидна унция}
    other {# флуидни унции}
  }`,
  PT: `{value, plural,
    =0 {0 пинти}
    one {1 пинта}
    other {# пинти}
  }`,
  QT: `{value, plural,
    =0 {0 кварти}
    one {1 кварта}
    other {# кварти}
  }`,
  MLT: `{value, plural,
    =0 {0 милилитра}
    one {1 милилитър}
    other {# милилитра}
  }`,
  ONZ: `{value, plural,
    =0 {0 унции}
    one {1 унция}
    other {# унции}
  }`,
  LBR: `{value, plural,
    =0 {0 паунда}
    one {1 паунд}
    other {# паунда}
  }`,
  STN: `{value, plural,
    =0 {0 тона}
    one {1 тон}
    other {# тона}
  }`,
  GRM: `{value, plural,
    =0 {0 грама}
    one {1 грам}
    other {# грама}
  }`,
  KGM: `{value, plural,
    =0 {0 килограма}
    one {1 килограм}
    other {# килограма}
  }`,
  TNE: `{value, plural,
    =0 {0 тона}
    one {1 тон}
    other {# тона}
  }`,
  PS: `{value, plural,
    =0 {0 psi}
    one {1 psi}
    other {# psi}
  }`,
  MPA: `{value, plural,
    =0 {0 мегапаскала}
    one {1 мегапаскал}
    other {# мегапаскала}
  }`,
  C56: `{value, plural,
    =0 {0 нютона на кв. милиметър}
    one {1 нютон на кв. милиметър}
    other {# нютона на кв. милиметър}
  }`,
  C62: `{value, plural,
    =0 {0 единица}
    one {1 единица}
    other {# единици}
  }`,
  NL: `{value, plural,
    =0 {0 зареждания}
    one {1 зареждане}
    other {# зареждания}
  }`,
  MT: `{value, plural,
    =0 {0 подложки}
    one {1 подложка}
    other {# подложки}
  }`,
  P1: `{value, plural,
    =0 {0 процента}
    one {1 процент}
    other {# процента}
  }`,
  CEL: `{value, plural,
    =0 {0 градуса по Целзий}
    one {1 градус по Целзий}
    other {# градуса по Целзий}
  }`,
  FAH: `{value, plural,
    =0 {0 градуса по Фаренхайт}
    one {1 градус по Фаренхайт}
    other {# градуса по Фаренхайт}
  }`,
  BLL: `{value, plural,
    =0 {0 барела}
    one {1 барел}
    other {# барела}
  }`,
  CLT: `{value, plural,
    =0 {0 сантилитра}
    one {1 сантилитър}
    other {# сантилитра}
  }`,
  DLT: `{value, plural,
    =0 {0 децилитра}
    one {1 децилитър}
    other {# децилитра}
  }`,
  GLI: `{value, plural,
    =0 {0 галона}
    one {1 галон}
    other {# галона}
  }`,
  '2U': `{value, plural,
    =0 {0 мегаграма}
    one {1 мегаграм}
    other {# мегаграма}
  }`,
  SA: `{value, plural,
    =0 {0 чувала}
    one {1 чувал}
    other {# чувала}
  }`,
  60: `{value, plural,
    =0 {0 процента тегло}
    one {1 процент тегло}
    other {# процента тегло}
  }`,
  BG: `{value, plural,
    =0 {0 торби}
    one {1 торба}
    other {# торби}
  }`,
  SEC: `{value, plural,
    =0 {0 секунди}
    one {1 секунда}
    other {# секунди}
  }`,
  64: `{value, plural,
    =0 {0 паунда на кв. инч - манометър}
    one {1 паунд на кв. инч - манометър}
    other {# паунда на кв. инч - манометър}
  }`,
  SP: `{value, plural,
    =0 {0 рафтови опаковки}
    one {1 рафтова опаковка}
    other {# рафтови опаковки}
  }`,
  MMK: `{value, plural,
    =0 {0 кв. милиметра}
    one {1 кв. милиметър}
    other {# кв. милиметра}
  }`,
  MTN: `{value, plural,
    =0 {0 метрични тона}
    one {1 метричен тон}
    other {# метрични тона}
  }`,
  GT: `{value, plural,
    =0 {0 гигатона}
    one {1 гигатон}
    other {# гигатона}
  }`,
  '/NL': `{value, plural,
    =0 {0 на зареждане}
    one {1 на зареждане}
    other {# на зареждане}
  }`,
  '/EA': `{value, plural,
    =0 {0 на количество}
    one {1 на количество}
    other {# на количество}
  }`,
  '/H/ + h': `{value, plural,
    =0 {0 на час}
    one {1 на час}
    other {# на час}
  }`,
  '/YQ/ + YDQ': `{value, plural,
    =0 {0 на куб. ярд}
    one {1 на куб. ярд}
    other {# на куб. ярд}
  }`,
  '/MQ/ + MTQ': `{value, plural,
    =0 {0 на куб. метър}
    one {1 на куб. метър}
    other {# на куб. метър}
  }`,
  '/MN/ + MIN': `{value, plural,
    =0 {0 на минута}
    one {1 на минута}
    other {# на минута}
  }`,
  '/MT': `{value, plural,
    =0 {0 на метър}
    one {1 на метър}
    other {# на метър}
  }`,
  DSG: `{value, plural,
    =0 {0 дозировка}
    one {1 дозировка}
    other {# дозировка}
  }`,
  '/C': `{value, plural,
    =0 {0 на 100 тегло}
    one {1 на 100 тегло}
    other {# на 100 тегло}
  }`,
  '64_2': `{value, plural,
    =0 {0 специфичен}
    one {1 специфичен}
    other {# специфични}
  }`,
  LTR_short: `{value, plural,
  =0 {0 л}
  one {1 л}
  other {# л}
  }`,
  TO_short: `{value, plural,
  =0 {0 т}
  one {1 т}
  other {# т}
}`,
  ITEM_short: `{value, plural,
  =0 {0 ед.}
  one {1 ед.}
  other {# ед.}
}`,
  GLL_short: `{value, plural,
  =0 {0 гал}
  one {1 гал}
  other {# гал}
}`,
  EA_short: `{value, plural,
  =0 {0 бр.}
  one {1 бр.}
  other {# бр.}
}`,
  MIN_short: `{value, plural,
  =0 {0 мин}
  one {1 мин}
  other {# мин}
}`,
  ACR_short: `{value, plural,
  =0 {0 ac}
  one {1 ac}
  other {# ac}
}`,
  HUR_short: `{value, plural,
  =0 {0 ч}
  one {1 ч}
  other {# ч}
}`,
  INH_short: `{value, plural,
  =0 {0 ин}
  one {1 ин}
  other {# ин}
}`,
  FOT_short: `{value, plural,
  =0 {0 фт}
  one {1 фт}
  other {# фт}
}`,
  YRD_short: `{value, plural,
  =0 {0 ярд}
  one {1 ярд}
  other {# ярд}
}`,
  MMT_short: `{value, plural,
  =0 {0 мм}
  one {1 мм}
  other {# мм}
}`,
  CMT_short: `{value, plural,
  =0 {0 см}
  one {1 см}
  other {# см}
}`,
  MTR_short: `{value, plural,
  =0 {0 м}
  one {1 м}
  other {# м}
}`,
  SMI_short: `{value, plural,
  =0 {0 мили (ст. мили)}
  one {1 миля (ст. миля)}
  other {# мили (ст. мили)}
}`,
  KMT_short: `{value, plural,
  =0 {0 км}
  one {1 км}
  other {# км}
}`,
  INK_short: `{value, plural,
  =0 {0 ин²}
  one {1 ин²}
  other {# ин²}
}`,
  FTK_short: `{value, plural,
  =0 {0 фт²}
  one {1 фт²}
  other {# фт²}
}`,
  YDK_short: `{value, plural,
  =0 {0 ярд²}
  one {1 ярд²}
  other {# ярд²}
}`,
  MIK_short: `{value, plural,
  =0 {0 ми²}
  one {1 ми²}
  other {# ми²}
}`,
  CMK_short: `{value, plural,
  =0 {0 см²}
  one {1 см²}
  other {# см²}
}`,
  MTK_short: `{value, plural,
  =0 {0 м²}
  one {1 м²}
  other {# м²}
}`,
  KMK_short: `{value, plural,
  =0 {0 км²}
  one {1 км²}
  other {# км²}
}`,
  INQ_short: `{value, plural,
  =0 {0 ин³}
  one {1 ин³}
  other {# ин³}
}`,
  MMQ_short: `{value, plural,
  =0 {0 мм³}
  one {1 мм³}
  other {# мм³}
}`,
  FTQ_short: `{value, plural,
  =0 {0 фт³}
  one {1 фт³}
  other {# фт³}
}`,
  CMQ_short: `{value, plural,
  =0 {0 см³}
  one {1 см³}
  other {# см³}
}`,
  OZA_short: `{value, plural,
  =0 {0 фл. унц.}
  one {1 фл. унц.}
  other {# фл. унц.}
}`,
  PT_short: `{value, plural,
  =0 {0 пт}
  one {1 пт}
  other {# пт}
}`,
  QT_short: `{value, plural,
  =0 {0 квт}
  one {1 квт}
  other {# квт}
}`,
  MLT_short: `{value, plural,
  =0 {0 мл}
  one {1 мл}
  other {# мл}
}`,
  ONZ_short: `{value, plural,
  =0 {0 унц.}
  one {1 унц.}
  other {# унц.}
}`,
  LBR_short: `{value, plural,
  =0 {0 фунта}
  one {1 фунт}
  other {# фунта}
}`,
  STN_short: `{value, plural,
  =0 {0 т}
  one {1 т}
  other {# т}
}`,
  GRM_short: `{value, plural,
  =0 {0 г}
  one {1 г}
  other {# г}
}`,
  KGM_short: `{value, plural,
  =0 {0 кг}
  one {1 кг}
  other {# кг}
}`,
  TNE_short: `{value, plural,
  =0 {0 т}
  one {1 т}
  other {# т}
}`,
  PS_short: `{value, plural,
  =0 {0 psi}
  one {1 psi}
  other {# psi}
}`,
  MPA_short: `{value, plural,
  =0 {0 МПа}
  one {1 МПа}
  other {# МПа}
}`,
  C56_short: `{value, plural,
  =0 {0 Н/мм²}
  one {1 Н/мм²}
  other {# Н/мм²}
}`,
  C62_short: `{value, plural,
  =0 {0 ед.}
  one {1 ед.}
  other {# ед.}
}`,
  NL_short: `{value, plural,
  =0 {0 зареждания}
  one {1 зареждане}
  other {# зареждания}
}`,
  MT_short: `{value, plural,
  =0 {0 подложки}
  one {1 подложка}
  other {# подложки}
}`,
  P1_short: `{value, plural,
  =0 {0 %}
  one {1 %}
  other {# %}
}`,
  CEL_short: `{value, plural,
  =0 {0 c}
  one {1 c}
  other {# c}
}`,
  FAH_short: `{value, plural,
  =0 {0 f}
  one {1 f}
  other {# f}
}`,
  BLL_short: `{value, plural,
  =0 {0 bbl}
  one {1 bbl}
  other {# bbl}
}`,
  CLT_short: `{value, plural,
  =0 {0 сл}
  one {1 сл}
  other {# сл}
}`,
  DLT_short: `{value, plural,
  =0 {0 дл}
  one {1 дл}
  other {# дл}
}`,
  GLI_short: `{value, plural,
  =0 {0 гал}
  one {1 гал}
  other {# гал}
}`,
  '2U_short': `{value, plural,
  =0 {0 мегаграма}
  one {1 мегаграм}
  other {# мегаграма}
}`,
  SA_short: `{value, plural,
  =0 {0 чувала}
  one {1 чувал}
  other {# чувала}
}`,
  '60_short': `{value, plural,
  =0 {0 % тегло}
  one {1 % тегло}
  other {# % тегло}
}`,
  BG_short: `{value, plural,
  =0 {0 торби}
  one {1 торба}
  other {# торби}
}`,
  SEC_short: `{value, plural,
  =0 {0 сек}
  one {1 сек}
  other {# сек}
}`,
  '64_short': `{value, plural,
  =0 {0 psi - манометър}
  one {1 psi - манометър}
  other {# psi - манометър}
}`,
  SP_short: `{value, plural,
  =0 {0 рафтови опаковки}
  one {1 рафтова опаковка}
  other {# рафтови опаковки}
}`,
  MMK_short: `{value, plural,
  =0 {0 кв. мм}
  one {1 кв. мм}
  other {# кв. мм}
}`,
  MTN_short: `{value, plural,
  =0 {0 т}
  one {1 т}
  other {# т}
}`,
  GT_short: `{value, plural,
  =0 {0 gt}
  one {1 gt}
  other {# gt}
}`,
  '/NL_short': `{value, plural,
  =0 {0 /зареждане}
  one {1 /зареждане}
  other {# /зареждане}
}`,
  '/EA_short': `{value, plural,
  =0 {0 /бр.}
  one {1 /бр.}
  other {# /бр.}
}`,
  '/H/ + h_short': `{value, plural,
  =0 {0 /час}
  one {1 /час}
  other {# /час}
}`,
  '/YQ/ + YDQ_short': `{value, plural,
  =0 {0 /ярд³}
  one {1 /ярд³}
  other {# /ярд³}
}`,
  '/MQ/ + MTQ_short': `{value, plural,
  =0 {0 /м³}
  one {1 /м³}
  other {# /м³}
}`,
  '/MN/ + MIN_short': `{value, plural,
  =0 {0 /мин}
  one {1 /мин}
  other {# /мин}
}`,
  '/MT_short': `{value, plural,
  =0 {0 /м}
  one {1 /м}
  other {# /м}
}`,
  DSG_short: `{value, plural,
  =0 {0 дозировка}
  one {1 дозировка}
  other {# дозировка}
}`,
  '/C_short': `{value, plural,
  =0 {0 /c}
  one {1 /c}
  other {# /c}
}`,
  '64_2_short': `{value, plural,
  =0 {0 специфичен}
  one {1 специфичен}
  other {# специфични}
}`,
  mixIdLabel: 'Идентификатор на смес/Описание',
  productIdLabel: 'Идентификатор на продукт/Описание',
  orderedQtyLabel: 'Поръчано количество',
  loadedQtyLabel: 'Заредено количество',
  addedByCustomer: 'Добавено от клиента',
  PRINTED: 'Билетиран',
  LOADING_STARTED: 'Старт на товарене',
  LOADING_COMPLETE: 'Край на товарене',
  TO_JOB: 'Напусна централата',
  ARRIVE_JOB: 'Пристигане на обект',
  UNLOADING: 'Старт на разтоварване',
  END_UNLOADING: 'Край на разтоварване',
  LEAVE_JOB: 'Напусни обект',
  IN_YARD: 'В двора',
  WASHING: 'Измиване',
  END_WASHING: 'Край на измиване',
  PUMPING_STARTED: 'Старт на помпа',
  PUMPING_COMPLETE: 'Край на помпа',
  READY_TO_PUMP: 'Готов за помпиране',
  FIRST_WCCONTACT: 'Първ контакт вода-цимент',
  plantName: 'Име на централа',
  plantAddress: 'Адрес на централа',
  loadingScheduleStart: 'Планирано време за товарене',
  deliveryAddress: 'Адрес за доставка',
  phoneNumber: 'Телефонен номер',
  unloadingScheduleStart: 'Планирано време за разтоварване (ETA)',
  agreedUnloading: 'Поръчани времена за разтоварване',
  deliveryInformation: 'Информация за доставка',
  next: 'Напред',
  material: 'Материал',
  loadingPoint: 'Точка на товарене',
  unloadingPoint: 'Точка на разтоварване',
  getDirections: 'Получи посоки',
  comment: 'Коментар',
  sapDeliveryNumber: 'Номер на SAP доставка (BCC номер)',
  salesOrderNumber: 'Номер на продажна поръчка и позиция',
  wcDateTime: 'Дата и час контакт W/C',
  po: 'Номер на поръчка',
  orderedByName: 'Поръчка направена от име',
  orderedByPhone: 'Поръчка направена от телефон',
  resourceId: 'Идентификатор на ресурс',
  totalLoadedQty: 'Общо заредено количество включително този товар',
  spacing: 'Интервал на товара',
  deliveryFlow: 'Поток на доставка',
  timeOnSite: 'Общо време на обект/поръчано време за разтоварване',
  salesText: 'Продажен текст (идентификатор на материал)',
  strengthClass: 'Клас на якост',
  environmentExposure: 'Експозиция на околната среда',
  metExposureClasses: 'Класове експозиция',
  dmax: 'Dmax',
  standardCert: 'Стандарт (сертификация)',
  workabilityTarget: 'Целева пригодност от клиента',
  stoneQuality: 'Качество на камък',
  sandQuality: 'Качество на пясък',
  targetWC: 'Целево съотношение W/C от рецепта',
  controlClass: 'Контролен клас',
  chlorideClass: 'Клас хлориди',
  typeAndStrength1: 'Тип цимент и клас якост 1',
  typeAndStrength2: 'Тип цимент и клас якост 2',
  typeOfAddition: 'Тип добавка',
  typeOfAdmixture: 'Тип примес',
  orderedTemp: 'Поръчана температура',
  fibers1: 'Тип и съдържание на влакна 1',
  fibers2: 'Тип и съдържание на влакна 2',
  calculatedMaturityTime: 'Изчислено време на узряване от контакт W/C',
  mixIdentity: 'Идентичност на смес',
  grade: 'Клас',
  mixType: 'Тип смес',
  maxAggSize: 'Макс. размер на зърно',
  maxAggType: 'Макс. тип зърно',
  cementType: 'Тип цимент',
  admixtures: 'Примеси',
  addmixDescription: 'Описание на добавка',
  slump: 'Провисване',
  minCementContent: 'Мин. съдържание цимент',
  maxWatCemRatio: 'Макс. съотношение вода/цимент',
  maxWaterToAdd: 'Макс. вода за добавяне',
  mortarMinWorkingLife: 'Мин. работен живот на хоросана',
  code: 'Код',
  dcClass: 'dcClass',
  chloride: 'Хлорид',
  signedByHanson: 'Подписано от Hanson',
  warmStamp: 'Топъл печат',
  coldStamp: 'Студен печат',
  containsSikatard: 'Съдържа Sikatard',
  containsDelvo: 'Съдържа Delvo',
  generalDelivery: 'Обща информация за доставка',
  materialInfo: 'Информация за материал',
  water: 'Вода',
  materialService: 'Материал / Услуга',
  returnedMaterial: 'Върнат материал',
  returnedConcrete: 'Върнат бетон',
  waterAdded: 'Добавена вода',
  concreteOnTruck: 'Бетон на камион',
  concreteOnTruckUom: 'Мерна единица за бетон на камион по подразбиране',
  reason: 'Причина',
  customerAddedWater: 'Клиентът добави вода',
  addWater: 'Добави вода',
  addedAt: 'Добавено в',
  addMaterialService: 'Добави материал/услуга',
  customerAddedProduct: 'Клиентът добави продукт',
  addReturnedMaterial: 'Добави върнат материал',
  leftover: 'Остатък',
  submitAcceptance: 'Изпрати приемане',
  accepted: 'Прието',
  rejected: 'Отхвърлено',
  customerAcceptance: 'Приемане',
  finalize: 'Финализирай',
  earlyAcceptance: 'Ранно приемане',
  materialSummary: 'Обобщение на материал',
  mix: 'Смес',
  ordered: 'Поръчано',
  loaded: 'Товар за доставка',
  totalOrdered: 'Общо поръчано количество',
  loadedOrderQuantity: 'Заредено поръчано количество',
  loadedOrder: 'Заредена поръчка',
  driverComment: 'Коментар на шофьор',
  driverCommentInternal: 'Коментар на шофьор (вътрешен)',
  customerComment: 'Коментар на клиент',
  editComment: 'Редактирай коментар',
  addComment: 'Добави коментар',
  additionalInfo: 'Допълнителна информация',
  onBoard: 'На борда',
  driver: 'Шофьор',
  commentInstruction: 'Инструкция за коментар',
  signatureInstruction: 'Подпис на клиент *',
  customerSignature: 'Подпис на клиент',
  general: 'Общо',
  status: 'Статус',
  updateStatusTime: 'Време на актуализация на статус',
  delete: 'Изтрий',
  cancel: 'Отказ',
  back: 'Назад',
  add: 'Добави',
  edit: 'Редактирай',
  done: 'Готово',
  ok: 'OK',
  decline: 'Отказ',
  Submit: 'Изпрати',
  submit: 'Изпрати',
  lastRefresh: 'Последно обновяване',
  refreshEnabled: 'Разреши обновяване',
  id: 'ID',
  name: 'Име',
  invoiceable: 'Фактурируем',
  provideSignature: 'Осигури подпис',
  ticket: 'Билет',
  details: 'Детайли',
  qrCode: 'QR код',
  driverAcceptanceReason: 'Причина',
  driverAcceptance: 'Приемане от шофьор',
  'payment-method': 'Методи на плащане',
  'add-payment-method': 'Добави метод на плащане',
  'reason-code': 'Код на причина',
  'add-reason-code': 'Добави код на причина',
  'qr-code': 'QR код',
  'unloading-method': 'Методи на разтоварване',
  'add-unloading-method': 'Добави метод на разтоварване',
  'driver-comment': 'Коментари на шофьор',
  'add-driver-comment': 'Добави коментар на шофьор',
  'driver-sellable': 'Продаваем от шофьор',
  vehicle: 'Превозни средства',
  'add-vehicle': 'Добави превозно средство',
  'vehicle-type': 'Типове превозни средства',
  vehicleTypes: 'Типове превозни средства',
  vehicleType: 'Тип превозно средство',
  'add-vehicle-type': 'Добави тип превозно средство',
  countries: 'Държави',
  country: 'Държава',
  type: 'Тип',
  uom: 'Мерна единица',
  mandatory: 'Задължително',
  qrTemplate: 'Шаблон на QR код',
  includeMixInfo: 'Включи информация за смес в QR код',
  includeTicketEvents: 'Включи събития по билет в QR код',
  quantityField: 'Разреши поле за количество',
  concreteOnTruckField: 'Разреши поле бетон на камион',
  materialOnTruckField: 'Разреши поле материал на камион',
  timeField: 'Разреши поле за време',
  reasonField: 'Разреши поле за причина',
  driverInstructions: 'Инструкции за шофьор',
  waitingForTicket: 'Изчакване на билет...',
  createTestTicketForTruck: 'Създай тестов билет за камион',
  exceedsLoadedQuantity: 'Стойността не може да надвишава зареденото количество от {loadedQuantity}.',
  maxQuantity: 'Максимално количество',
  maxQuantityError: 'Количеството не може да надвишава определеното максимум от {maxQty}',
  maxValueError: 'Стойността не може да надвишава определеното максимум от {maxQty}',
  minValueError: 'Стойността не може да бъде по-малка от определеното минимум от {minQty}',
  notAuthorized: 'Не е упълномощен',
  enterTruckNumber: 'Въведете номер на камион',
  setTruckNumber: 'Задай номер на камион',
  commentList: 'Списък с коментари',
  list: 'Списък',
  gridPreferences: 'Настройки на мрежа',
  loadingUnloadingPoints: 'Точки на товарене/разтоварване',
  activity: 'Дейност',
  crn: 'Crn',
  update: 'Актуализирай',
  CONCRETE: 'Бетон',
  WATER: 'Вода',
  ADDITIVE: 'Добавка',
  'submit-signature-button': 'Приеми',
  'cancel-signature-button': 'Отказ',
  uomCode: 'Мерна единица по подразбиране',
  'product-type': 'Типове продукти',
  'add-product-type': 'Добави тип продукт',
  'add-product': 'Добави продукт',
  'setup_driver-comment': 'Коментари на шофьор',
  setup_product: 'Продукти',
  'setup_product-type': 'Типове продукти',
  'setup_qr-code': 'QR код',
  'setup_reason-code': 'Кодове причини',
  'setup_unloading-method': 'Методи на разтоварване',
  'setup_entity-mt': 'Компания',
  setup_vehicle: 'Превозни средства',
  'setup_vehicle-type': 'Типове превозни средства',
  'setup_data-retentions': 'Запазване на данни',
  'add-data-retentions': 'Добави запазване на данни',
  'data-retentions': 'Запазване на данни',
  setup_carriers: 'Превозвачи',
  'add-carriers': 'Добави превозвачи',
  carriers: 'Превозвачи',
  'setup_concrete-classes': 'Съответствие на материал',
  'add-concrete-classes': 'Добави съответствие на материал',
  'concrete-classes': 'Съответствие на материал',
  'setup_forms-and-waivers': 'Формуляри и отказ от отговорност',
  'add-forms-and-waivers': 'Добави формуляри и отказ',
  'forms-and-waivers': 'Формуляри и отказ',
  companyFleet: 'Автопарк на компанията',
  category: 'Категория',
  interval: 'Интервал',
  orders: 'Поръчки и билети',
  '30days': '30 дни',
  '60days': '60 дни',
  '90days': '90 дни',
  '1year': '1 година',
  '3years': '3 години',
  waterMandatory: 'Вода задължителна',
  qrCodeTemplate: 'Шаблон на QR код',
  waterConfig: 'Допълнителни полета',
  waterProduct: 'Вода',
  waterProductType: 'Тип воден продукт',
  defaultWaterProduct: 'Воден продукт по подразбиране',
  invalidTemplate: 'Невалиден шаблон',
  siteAddress: 'Адрес на обект',
  siteContactName: 'Име на контакт на обект',
  siteContactPhoneNumber: 'Телефон на контакт на обект',
  'clear-signature-button': 'Изчисти подпис',
  customerCommentEnabled: 'Разреши коментар на клиент',
  driverCommentEnabled: 'Разреши коментар на шофьор',
  driverCommentMaxCharacters: 'Макс. дължина',
  customerCommentMaxCharacters: 'Макс. дължина',
  timeZone: 'Часова зона',
  driverDidNotAdd: 'Шофьорът не добави',
  noWaterAdded: 'Шофьорът не добави',
  maxLineItems: 'Макс. брой позиции',
  oneLineItem: 'Трябва да има поне 1 позиция',
  signatureSiteContact: 'Име на клиент',
  signatureSiteContactMandatory: 'Име на клиент *',
  ticketEvents: 'Събития по билет',
  hideEvent: 'Скрий събитие',
  editable: 'Редактируем',
  ticketDetail: `Билет #{value}`,
  statusTimes: 'Времена на статус',
  materialAndDeliveryInfo: 'Информация за материал и доставка',
  customerRejection: 'Отхвърляне от клиент',
  'submit-rejection-button': 'Изпрати отхвърляне',
  accept: 'Приеми',
  reject: 'Отхвърли товар',
  signature: 'Подпис',
  'no-signature': 'Без подпис',
  unFinalizePassword: 'Парола за отмяна на финализация',
  waterInWorkflow: 'Разреши стъпка вода в работния процес',
  multicountry: 'Мултидържава',
  timestampAfterSequence: 'ПРЕДУПРЕЖДЕНИЕ: Времето не трябва да е преди предишното',
  timestampBeforeSequence: 'ПРЕДУПРЕЖДЕНИЕ: Времето не трябва да е след следващото',
  noRestQuantity: 'Няма върнат материал',
  returnedMaterialMandatory: 'Трябва да взаимодейства със стъпка върнат материал',
  driverCommentMaxChars: 'Дължината не може да надвишава макс. от {maxLength} символа.',
  QrCodeEnabled: 'Разреши QR код',
  QrMethod_linkBased: 'На база връзка',
  QrMethod_contentBased:
    'На база съдържание, ЗАБЕЛЕЖКА: QR кодовете на база съдържание имат ограничения, които могат да причинят проблеми над 1024 символа.',
  QrMethod_contentBasedWarning: 'ЗАБЕЛЕЖКА: Този QR код има {amount} символа, които може да не се четат на някои телефони.',
  returnedMaterialInWorkflow: 'Разреши стъпка върнат материал в работния процес',
  materialServiceInWorkflow: 'Разреши стъпка материал/услуга в работния процес',
  totalPumpedQuantity: 'Общо помпирано количество',
  concrete: 'Бетон',
  materialComplianceEnabled: 'Разреши съответствие на материал',
  pumpStatusTimes: 'Времена на статус на помпа',
  pollingInterval: 'Интервал на проверка (секунди)',
  tenSecs: 'Интервалът трябва да е поне 10 секунди',
  materialCompliance: 'Съответствие на материал',
  materialCompliance_notFound: 'Съответствие на материал не е намерено',
  materialCompliance_outOfRange_warning: 'Въведената стойност е извън диапазона на толеранс на класа на бетона.',
  consistenceValue: 'Консистенция - провисване',
  consistenceIsCompliant: 'Консистенцията отговаря на BS8500-2',
  airContentValue: 'Съдържание на въздух',
  airContentIsCompliant: 'Съдържанието на въздух отговаря на BS8500-2',
  consistenceIsCompliantShort: 'Консистенцията отговаря',
  airContentIsCompliantShort: 'Съдържанието на въздух отговаря',
  compliance: 'Съответствие на материал с BS8500-2',
  termsAndConditionsEnabled: 'Разреши формуляр условия',
  termsAndConditions: 'Условия за ползване',
  damageWaiverEnabled: 'Разреши формуляр отказ от щети',
  damageWaiver: 'Отказ от щети',
  damageWaiverAcknowledged: 'Отказ от щети признат',
  dynamicWaiver: 'Динамичен отказ',
  dynamicWaiverEnabled: 'Разреши динамичен формуляр за отказ',
  ticketListEnabled: 'Разреши списък с билети',
  clearTicketAfterSubmission: 'Изчисти билет след изпращане',
  keepTicketOpenAfterSubmission: 'Запази билет отворен след изпращане',
  displayTicketList: 'Покажи списък с билети',
  supportedLanguages: 'Поддържани езици',
  allow: 'Разреши',
  default: 'По подразбиране',
  isCertificationLossTriggerForReason: 'Причина за забележка за загуба на сертификат',
  isCertificationLossTriggerForProduct: 'Продукт за забележка за загуба на сертификат',
  translations: 'Преводи',
  family_name: 'Фамилия',
  given_name: 'Собствено име',
  email: 'Имейл',
  role: 'Роля',
  inviteUser: 'Покани потребител',
  carrier: 'Превозвач',
  emailOrPhoneNumber: 'Имейл',
  usersEditor: 'Редактор на потребители',
  verifyPassword: 'Потвърди парола',
  verificationCode: 'Код за потвърждение',
  register: 'Регистрация',
  registerInstructions: 'Моля, попълнете този формуляр, за да завършите регистрацията си.',
  'password-requirements':
    'Паролата трябва да съдържа поне 8 символа, поне 1 главна буква, 1 малка буква, 1 цифра и 1 специален символ.',
  passwordMinCharacters: 'Паролата трябва да съдържа 8 или повече символа.',
  passwordMaxCharacters: 'Паролата не може да съдържа повече от 99 символа.',
  passwordLowerCase: 'Паролата трябва да съдържа поне 1 малка буква.',
  passwordUpperCase: 'Паролата трябва да съдържа поне 1 главна буква.',
  passwordNumber: 'Паролата трябва да съдържа поне 1 цифра.',
  passwordSpecialCharacter: 'Паролата трябва да съдържа поне 1 специален символ.',
  passwordsDontMatch: 'Паролите не съвпадат!',
  success: 'Успех!',
  'registration-success': 'Регистрацията ви беше успешна.',
  'post-registration-instructions': 'Завършихте процеса на регистрация. Сега можете да влезете.',
  createDate: 'Дата на създаване',
  customerPo: 'Номер на поръчка на клиент',
  specification: 'Спецификация',
  description: 'Описание',
  classType: 'Тип клас',
  minimumValue: 'Минимална стойност',
  maximumValue: 'Максимална стойност',
  TrackIt: 'TrackIt',
  trackIt3PContext: 'TrackIt 3P контекст',
  inviteLanguage: 'Език на покана',
  truckNumber: 'Номер на камион',
  adverseTemperature:
    'Температурата на околната среда по време на смесването беше такава, че не можем да гарантираме, че бетонът ще бъде в температурния диапазон 5-35°C, както е посочено в EN 206.',
  environmentalNote:
    'Това зареждане съдържа екологичен агент, който не надвишава 0,03% от теглото на бетона. Водата, съдържаща този материал за производство на бетон, ще съответства на BS EN 1008.',
  unloadingMethodEnabled: 'Разреши метод на разтоварване',
  warrantyVoided: 'Гаранцията на материала е анулирана',
  materialWarrantyVoidedEnabled:
    'При използване на продукт за забележка за загуба на сертификат или продукт и код на причина, показвай забележка при подпис.',
  'setup_templates-mt': 'Шаблони',
  copyFrom: 'Копирай от...',
  copy: 'копие',
  users: 'Потребители',
  setup: 'Настройки',
  driverExperience: 'Опит на водача',
  ticketList: 'Списък с билети',
  content: 'Съдържание',
  WARNINGS: 'Предупреждения',
  TERMS: 'Условия',
  DAMAGE: 'Повреди',
  ADDITIONALWAIVER: 'Допълнителен отказ',
  DYNAMICWAIVER: 'Динамичен отказ',
  source: 'Източник',
  sensorUnable: 'Сензорът не може да определи остатъчното количество.',
  PROBE: 'Сонда',
  DRIVER: 'Шофьор',
  DRS: 'DRS',
  waterReleaseFormEnabled: 'Разреши формуляр освобождаване на вода',
  waterRelease: 'Освобождаване на вода',
  waterReleaseMandatory: 'Освобождаване на вода *',
  waterReleaseAcknowledged: 'Освобождаване на вода признато',
  'assessment-risk': 'Оценка на риска',
  'setup_assessment-risk': 'Оценка на риска',
  'add-assessment-risk': 'Добави оценка на риска',
  enterRecipientsButton: 'Въведете получател(и)',
  recipientsInstructions: 'Въведете имейл, разделен със запетая',
  enter: 'Въведи',
  invalidEmailAddress: 'невалиден имейл адрес',
  personalDataPolicy:
    'Въвеждайки лични данни в този формуляр, потвърждавате, че имате необходимите разрешения за споделяне на тези данни',
  subcategory: 'Подкатегория',
  isRequired: 'Задължително',
  riskAssessmentEnabled: 'Разреши оценка на риска',
  riskAssessment: 'Оценка на риска',
  yes: 'Да',
  no: 'Не',
  sourceOptionsSensors: 'Опции на източник (сензори)',
  sourceDcm: 'DCM',
  sourceProbe: 'Сонда',
  availableCustomValues: 'Налични персонализирани стойности',
  ERR_CODE__DUPLICATE: 'Дубликат',
  ERR_CODE__DEFAULT_VALUE: 'Вече има стойност по подразбиране',
  ERR_CODE__EXISTING_FORM: 'Вече има активен формуляр за това превозно средство и тип',
  availableValues: 'Налични стойности',
  pump: 'Помпа',
  DanskName: 'Датско име',
  GermanName: 'Немско име',
  EnglishName: 'Английско име',
  BritainName: 'Британско име',
  SpanishName: 'Испанско име',
  FrenchName: 'Френско име',
  NederlandsName: 'Холандско име',
  NorskName: 'Норвежко име',
  SvenskaName: 'Шведско име',
  ItalianName: 'Италианско име',
  PolishName: 'Полско име',
  DanskNameDefault: 'Датско име (по подразбиране)',
  GermanNameDefault: 'Немско име (по подразбиране)',
  EnglishNameDefault: 'Английско име (по подразбиране)',
  BritainNameDefault: 'Британско име (по подразбиране)',
  SpanishNameDefault: 'Испанско име (по подразбиране)',
  FrenchNameDefault: 'Френско име (по подразбиране)',
  NederlandsNameDefault: 'Холандско име (по подразбиране)',
  NorskNameDefault: 'Норвежко име (по подразбиране)',
  SvenskaNameDefault: 'Шведско име (по подразбиране)',
  ItalianNameDefault: 'Италианско име (по подразбиране)',
  PolishNameDefault: 'Полско име (по подразбиране)',
  DanskDescription: 'Датско описание',
  GermanDescription: 'Немско описание',
  EnglishDescription: 'Английско описание',
  BritainDescription: 'Британско описание',
  SpanishDescription: 'Испанско описание',
  FrenchDescription: 'Френско описание',
  NederlandsDescription: 'Холандско описание',
  NorskDescription: 'Норвежко описание',
  SvenskaDescription: 'Шведско описание',
  ItalianDescription: 'Италианско описание',
  PolishDescription: 'Полско описание',
  DanskDescriptionDefault: 'Датско описание (по подразбиране)',
  GermanDescriptionDefault: 'Немско описание (по подразбиране)',
  EnglishDescriptionDefault: 'Английско описание (по подразбиране)',
  BritainDescriptionDefault: 'Британско описание (по подразбиране)',
  SpanishDescriptionDefault: 'Испанско описание (по подразбиране)',
  FrenchDescriptionDefault: 'Френско описание (по подразбиране)',
  NederlandsDescriptionDefault: 'Холандско описание (по подразбиране)',
  NorskDescriptionDefault: 'Норвежко описание (по подразбиране)',
  SvenskaDescriptionDefault: 'Шведско описание (по подразбиране)',
  ItalianDescriptionDefault: 'Италианско описание (по подразбиране)',
  PolishDescriptionDefault: 'Полско описание (по подразбиране)',
  DanskContent: 'Датско съдържание',
  GermanContent: 'Немско съдържание',
  EnglishContent: 'Английско съдържание',
  BritainContent: 'Британско съдържание',
  SpanishContent: 'Испанско съдържание',
  FrenchContent: 'Френско съдържание',
  NederlandsContent: 'Холандско съдържание',
  NorskContent: 'Норвежко съдържание',
  SvenskaContent: 'Шведско съдържание',
  ItalianContent: 'Италианско съдържание',
  PolishContent: 'Полско съдържание',
  DanskContentDefault: 'Датско съдържание (по подразбиране)',
  GermanContentDefault: 'Немско съдържание (по подразбиране)',
  EnglishContentDefault: 'Английско съдържание (по подразбиране)',
  BritainContentDefault: 'Британско съдържание (по подразбиране)',
  SpanishContentDefault: 'Испанско съдържание (по подразбиране)',
  FrenchContentDefault: 'Френско съдържание (по подразбиране)',
  NederlandsContentDefault: 'Холандско съдържание (по подразбиране)',
  NorskContentDefault: 'Норвежко съдържание (по подразбиране)',
  SvenskaContentDefault: 'Шведско съдържание (по подразбиране)',
  ItalianContentDefault: 'Италианско съдържание (по подразбиране)',
  PolishContentDefault: 'Полско съдържание (по подразбиране)',
  DanskCategory: 'Датска категория',
  GermanCategory: 'Немска категория',
  EnglishCategory: 'Английска категория',
  BritainCategory: 'Британска категория',
  SpanishCategory: 'Испанска категория',
  FrenchCategory: 'Френска категория',
  NederlandsCategory: 'Холандска категория',
  NorskCategory: 'Норвежка категория',
  SvenskaCategory: 'Шведска категория',
  ItalianCategory: 'Италианска категория',
  PolishCategory: 'Полска категория',
  DanskCategoryDefault: 'Датска категория (по подразбиране)',
  GermanCategoryDefault: 'Немска категория (по подразбиране)',
  EnglishCategoryDefault: 'Английска категория (по подразбиране)',
  BritainCategoryDefault: 'Британска категория (по подразбиране)',
  SpanishCategoryDefault: 'Испанска категория (по подразбиране)',
  FrenchCategoryDefault: 'Френска категория (по подразбиране)',
  NederlandsCategoryDefault: 'Холандска категория (по подразбиране)',
  NorskCategoryDefault: 'Норвежка категория (по подразбиране)',
  SvenskaCategoryDefault: 'Шведска категория (по подразбиране)',
  ItalianCategoryDefault: 'Италианска категория (по подразбиране)',
  PolishCategoryDefault: 'Полска категория (по подразбиране)',
  DanskSubcategory: 'Датска подкатегория',
  GermanSubcategory: 'Немска подкатегория',
  EnglishSubcategory: 'Английска подкатегория',
  BritainSubcategory: 'Британска подкатегория',
  SpanishSubcategory: 'Испанска подкатегория',
  FrenchSubcategory: 'Френска подкатегория',
  NederlandsSubcategory: 'Холандска подкатегория',
  NorskSubcategory: 'Норвежка подкатегория',
  SvenskaSubcategory: 'Шведска подкатегория',
  ItalianSubcategory: 'Италианска подкатегория',
  PolishSubcategory: 'Полска подкатегория',
  DanskSubcategoryDefault: 'Датска подкатегория (по подразбиране)',
  GermanSubcategoryDefault: 'Немска подкатегория (по подразбиране)',
  EnglishSubcategoryDefault: 'Английска подкатегория (по подразбиране)',
  BritainSubcategoryDefault: 'Британска подкатегория (по подразбиране)',
  SpanishSubcategoryDefault: 'Испанска подкатегория (по подразбиране)',
  FrenchSubcategoryDefault: 'Френска подкатегория (по подразбиране)',
  NederlandsSubcategoryDefault: 'Холандска подкатегория (по подразбиране)',
  NorskSubcategoryDefault: 'Норвежка подкатегория (по подразбиране)',
  SvenskaSubcategoryDefault: 'Шведска подкатегория (по подразбиране)',
  ItalianSubcategoryDefault: 'Италианска подкатегория (по подразбиране)',
  PolishSubcategoryDefault: 'Полска подкатегория (по подразбиране)',
  priorSignatures: 'Предишни подписи',
  damageWaiverSignature: 'Подпис за отказ от щети',
  waterReleaseSignature: 'Подпис за освобождаване на вода',
  errors,
  themes,
  isPDFRecipientListEnable: 'Разреши списък с получатели на PDF на екрана за подпис',
  isRejectLoadsEnable: 'Разреши отхвърляне на товари след пристигане',
  rejectLoad_returnedMaterial: 'Бутон за върнат материал в работния процес',
  rejectLoad_returnedAndFinalize: 'Бутони за върнат материал и финализация',
  driverRejection: 'Отхвърли товар',
  submitRejection: 'Изпрати отхвърляне',

  costAndPaymentsSummary: 'Обобщение на разходи и плащания',
  groupCostPriorTotal: 'Предходна обща сума на доставка',
  subtotal: 'Междинна сума',
  tax: 'Данък',
  remainingBalance: 'Оставащо салдо',
  paymentAmount: 'Сума за плащане',
  total: 'Общо',
  paymentMethod: 'Метод на плащане',
  paymentProducts: 'Продукти',
  unitPrice: 'Единична цена',
  amount: 'Сума',
  otherPaymentMethod: 'Друг метод на плащане',
  method: 'Метод',
  paymentOptions: 'Опции за плащане',
  typeAdditionalInfo: 'Въведете допълнителна информация тук',
  COD: 'Плащане при доставка',
  AMEX: 'American Express',
  CASH: 'Пари в брой',
  CHECK: 'Чек',
  'CREDIT CARD': 'Кредитна карта',
  ACCOUNT: 'Отворена сметка',
  UNKNOWN: 'Неизвестно',
  remainingMaterial: 'Оставащ материал',
  splitLoad: 'Разделен товар - Множество',
  isEnablePaymentAndCostWorkflows: 'Разреши работни процеси за плащане и разходи',

  // DOT Workflow
  dotWorkflow: 'Детайли на партида',
  inspectorSignature: 'Подпис на инспектор',
  producerSignature: 'Подпис на производител',
  addedItems: 'Добавени артикули',
  producerSignatureContact: 'Име на производител',
  inspectorSignatureContact: 'Име на инспектор',

  //
  airTempValue: 'Температура на въздуха',
  concreteTempValue: 'Температура на бетона',
  cylinderNumber: 'Номер на цилиндър',
  materialOnTruck: 'Материал на камион',
  waterLocation: 'Местоположение на вода',
  waterAtPlant: 'Вода в централа (gl)',
  waterAtJobsite: 'Вода на обект (gl)',
  totalActualWater: 'Общо фактическа вода',
  timeDischarged: 'Време на разтоварване',
  // news
  ingredient: 'Съставка',
  mcFac: 'MCFac',
  absFac: 'ABSFAC',
  od: 'OD',
  abs: 'ABS',
  ssd: 'SSD',
  freeMst: 'Безплатен Mst',
  cydsTarg: 'CYDS TARG',
  target: 'Целева',
  actual: 'Фактическа',
  freWat: 'Свободна вода',
  trim: 'Подстригване',
  batchInformation: 'Информация за партида',
  numberOfBatches: 'Брой партиди',
  totalWater: 'Общо вода',
  designWater: 'Проектна вода',
  toAdd: 'За добавяне',
  designWC: 'Проектно W/C',
  waterCement: 'Вода / Цимент',
  waterInTruck: 'Вода в камион',
  adjustWater: 'Регулирай вода',
  trimWater: 'Подстригване на вода',
  plantWeather: 'Времето в централа',
  rh: 'RH',
  observationTime: 'Време на наблюдение',
  address: 'Адрес',
  plant: 'Централа',
  sp: 'S.P. #',
  beginTime: 'Начален час',
  mixDesc: 'Описание на смес',
  qtyOder: 'Поръчано кол.',
  poTag: 'Поръчка #',
  bridge: 'Мост #',
  volume: 'Обем',
  truckTag: 'Камион #',
  qtyDelivered: 'Доставено кол.',
  qtyOrder: 'Поръчано кол.',
  job: 'Обект #',
  batchRecord: 'Запис на партида',
  mixID: 'ID на смес',
  loads: 'Товари',
  isDot: 'DOT',
  onlyPrimaryLineItem: 'Само основна позиция',
  tolStatus: 'Статус TOL',
  lastUpdate: 'Последна актуализация',
  driverClickedFinalize: 'Шофьорът натисна Финализирай',
  autoSubmit: 'Автоматично изпращане',
  noTaxInformationIsAvailable: 'Информация за данъците не е налична',
  retryPullTaxInformation: 'Обнови данни за данъци',
  var: '% Var',
  designQTY: 'Проектно кол.',
  batched: 'Партидиран',
  moisture: 'Влажност',
  actualWater: 'Фактическа вода',
  moisturePercent: '% влажност',
  freeWater: 'Свободна вода',
  reset: 'Нулирай',
  'at-plant': 'В централа',
  'at-job': 'На обект',
  viewTickets: 'Преглед на билети',
  viewSchedule: 'Преглед на график',
  viewActiveTicket: 'Преглед на активен билет',
  dateSelector_last_week: 'Миналата седмица',
  dateSelector_yesterday: 'Вчера',
  dateSelector_tomorrow: 'Утре',
  dateSelector_today: 'Днес',
  gridHeader_created: 'Създаден',
  gridHeader_customerStatus: 'Статус на клиент',
  gridHeader_ticketId: 'Билет',
  gridHeader_vehicle: 'Превозно средство',
  gridFooter_retrieved: 'Извлечени',
  gridFooter_loading: 'Зареждане...',
  general: {
    ...CAI_MATERIAL.i18n['en-US'].general,
  },
  component: {
    ...CAI_MATERIAL.i18n['en-US'].component,
  },
  attachments: 'Прикачени файлове',
  priorOrderCostTotal: 'Предходна обща сума',
  priorOrderPaymentTotal: 'Предходни плащания',
  orderShippedCostTotal: 'Обща сума на поръчка',
  orderShippedBalance: 'Салдо на поръчка',
  ticketSubtotal: 'Междинна сума на билет',
  ticketTax: 'Данък на билет',
  ticketTotal: 'Обща сума на билет',
  driverId: 'ID на шофьор',
  ticketStatus: 'Статус на билет',
  voided: 'Анулиран',
  ticketVoidedNotification: 'Този билет е анулиран.',
  ticketed: 'Издаден',
};
